import { RectPickerBase } from "../common/rect-picker-base";

export class DefaultCanvasRectPicker extends RectPickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer;
    }
}
//# sourceMappingURL=rect-picker.js.map
